import React from 'react';
import { FaClipboardCheck } from 'react-icons/fa';
import { BsLayoutSplit } from 'react-icons/bs';
import { BsArrowClockwise } from 'react-icons/bs';
import { useHistory } from 'react-router-dom';
import Card from '~/Components/Card';
import { Content, Header, CardsContainer } from './styles';
import { COLORS } from '~/styles/colors';
import Footer from '~/Components/Footer';

function AprovacaoDeProjetos() {
	const history = useHistory();
	return (
		<>
			<Content>
				<Header>APROVAÇÃO DE PROJETOS</Header>
				<p>Links úteis</p>
				<CardsContainer>
					<Card
						backgroundColor={COLORS.bgCard2}
						textColor={COLORS.fgCard2}
						href="https://servicos.prefeituradivinopolis.com.br/govdigital/Microsservicos/instrucao/161"
						target="_blank"
						icon={
							<FaClipboardCheck
								size={48}
								color={COLORS.fgCard2}
							/>
						}
						text={
							<span
								style={{
									display: 'flex',
									flexDirection: 'column',
								}}
							>
								<span>
									Aprovação de Projetos Arquitetônicos
								</span>
							</span>
						}
					/>
					<Card
						backgroundColor={COLORS.bgCard2}
						textColor={COLORS.fgCard2}
						onClick={() =>
							history.push(
								'/media/aprovacao-de-projetos/parcelamentos-do-solo-urbano'
							)
						}
						target="_self"
						icon={
							<BsLayoutSplit size={48} color={COLORS.fgCard2} />
						}
						text={
							<span
								style={{
									display: 'flex',
									flexDirection: 'column',
								}}
							>
								<span>PARCELAMENTO DO SOLO URBANO</span>
							</span>
						}
					/>
					<Card
						backgroundColor={COLORS.bgCard2}
						textColor={COLORS.fgCard2}
						href="https://www.prefeituradivinopolis.com.br/geoplantas/atualizacao-alteracao-cadastral"
						target="_blank"
						icon={
							<BsArrowClockwise size={48} color={COLORS.fgCard2} />
						}
						text={
							<span
								style={{
									display: 'flex',
									flexDirection: 'column',
								}}
							>
								<span>ATUALIZAÇÃO / ALTERAÇÃO CADASTRAL</span>
							</span>
						}
					/>
				</CardsContainer>
			</Content>
			<Footer />
		</>
	);
}

export default AprovacaoDeProjetos;
